import { Loader2Icon } from "lucide-react";

import { cn } from "@/lib/utils";

/**
 * Upstream shadcn's Spinner, verbatim: `Loader2Icon` at `size-4 animate-spin`
 * with `role="status"` and an accessible name.
 *
 * The product had 223 `animate-spin` occurrences across 78 files and no
 * primitive — spelled `h-3`, `h-3.5`, `h-4`, `h-5`, `size-3.5` and `size-4`,
 * with and without margins. `IntegrationsPage.tsx` alone carried 21 at three
 * different sizes. That is the loading-state equivalent of the 100 raw
 * `<select>`s, and it is why no two loading moments in the product looked
 * alike.
 *
 * The accessible name matters more than the size: a bare spinning icon
 * announces nothing, so a screen-reader user got silence where a sighted
 * user got a spinner. Callers that already label the surrounding region can
 * pass `aria-label=""`; callers with their own copy ("Saving…") should keep
 * it and let this stay decorative.
 *
 * Size comes from `className` — `size-3` through `size-5` — rather than a
 * variant, because that is what upstream does and because a margin
 * (`mr-1.5`) rides on the same prop at most call sites.
 */
export function Spinner({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <Loader2Icon
      role="status"
      aria-label="Loading"
      className={cn("size-4 animate-spin", className)}
      {...props}
    />
  );
}
